import ObjectUtils from '../../../utils/objectUtils';

// Shared utilities for document handling across different modules
export function updateDocument(classname: string, key: string, state: any, payload: any) {
    if (payload.document_class === classname) {
        const customKey = payload.document_class + '_id';
        const idClass = payload[customKey];
        return {
            ...state,
            [key]: {
                ...state[key],
                [idClass]: {
                    ...state[key][idClass],
                    documents: {
                        ...state[key][idClass].documents,
                        [payload.document_type]: payload.id,
                    },
                },
            },
        };
    }
    return state;
}

export function editDocumentData(state: any, action: any) {
    const partnerDocs = action.payload.documents;
    if (!partnerDocs) {
        return state;
    }
    action = {
        ...action,
        payload: { ...action.payload, documents: ObjectUtils.keepIds(partnerDocs) },
    };
    const newDocs = {};
    const docs = Object.values(partnerDocs) as any[];
    for (const doc of docs) {
        newDocs[doc.id] = doc;
    }
    return { ...state, documents: { ...state.documents, ...newDocs } };
}
